"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ahooks = require("ahooks");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _space = _interopRequireDefault(require("../space"));
var _jsxRuntime = require("react/jsx-runtime");
const ChipsGroup = props => {
  const {
    multiple,
    size = 'm',
    type = 'outline',
    spaceSize = 'l',
    itemWidth,
    block,
    requiredValue = false,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    children,
    direction,
    width,
    align
  } = props;
  const baseClassName = "".concat(prefixClass, "-chipsGroup");
  const [value, onChange] = (0, _ahooks.useControllableValue)(props, {
    defaultValue: undefined,
    defaultValuePropName: 'defaultValue',
    valuePropName: 'value',
    trigger: 'onChange'
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_space.default, {
    wrap: "wrap",
    size: spaceSize,
    itemWidth: itemWidth,
    className: (0, _classnames.default)(className, baseClassName),
    style: {
      ...style,
      width
    },
    align: align,
    direction: direction,
    block: block,
    children: _react.default.Children.map(children, (child, index) => {
      var _child$props$active, _child$props$onClick;
      return /*#__PURE__*/_react.default.isValidElement(child) ? /*#__PURE__*/_react.default.cloneElement(child, {
        prefixClass,
        size,
        type,
        active: (_child$props$active = child.props.active) !== null && _child$props$active !== void 0 ? _child$props$active : !multiple ? child.props.value === value : value === null || value === void 0 ? void 0 : value.some(i => i === child.props.value),
        onClick: (_child$props$onClick = child.props.onClick) !== null && _child$props$onClick !== void 0 ? _child$props$onClick : () => {
          const currentValue = child.props.value;
          if (!multiple) {
            if (currentValue === value) {
              !requiredValue && onChange(undefined, child.props);
            } else {
              onChange(currentValue, child.props);
            }
          } else {
            if (value !== null && value !== void 0 && value.some(i => i === currentValue)) {
              const newValue = (value || []).filter(i => i !== currentValue);
              if (newValue.length === 0 && requiredValue) {
                return;
              }
              onChange(newValue, child.props);
            } else {
              onChange([...(value || []), currentValue], child.props);
            }
          }
        }
      }) : child;
    })
  });
};
var _default = exports.default = ChipsGroup;